/**
 * AdManager - Lazy-loaded AdSense mit Cookie-Consent
 * @copyright reDim GmbH | @link https://www.redim.de | @contact team@redim.de
 */

export class AdManager {
    constructor() {
        this.loaded = false;
        this.clientId = null;
        this.slots = [];
    }

    /**
     * Initialisiert mit AdSense Client-ID
     * @param {string} clientId - Google AdSense Publisher-ID (ca-pub-XXXXXXX)
     */
    init(clientId) {
        if (!clientId || clientId === 'ca-pub-XXXXXXX') return;
        this.clientId = clientId;

        window.addEventListener('cookieConsentChanged', (e) => {
            if (e.detail.marketing) {
                this.loadAdSense();
            }
        });

        try {
            const consent = JSON.parse(localStorage.getItem('boomfection_cookie_consent'));
            if (consent?.marketing) {
                this.loadAdSense();
            }
        } catch {
            /* expected — localStorage unavailable or consent entry is corrupt JSON */
        }
    }

    loadAdSense() {
        if (this.loaded || !this.clientId) return;
        this.loaded = true;

        const script = document.createElement('script');
        script.async = true;
        script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${this.clientId}`;
        script.crossOrigin = 'anonymous';
        document.head.appendChild(script);

        script.onload = () => {
            this.slots.forEach((slot) => this.activateSlot(slot));
        };
    }

    /**
     * Registriert einen Ad-Slot (Element-ID)
     * @param {string} elementId - ID des Ad-Containers
     */
    registerSlot(elementId) {
        this.slots.push(elementId);
        if (this.loaded) {
            this.activateSlot(elementId);
        }
    }

    activateSlot(elementId) {
        const el = document.getElementById(elementId);
        if (!el) return;
        el.style.display = 'block';

        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch {
            /* expected — adsbygoogle script not yet loaded or blocked by ad-blocker */
        }
    }

    /**
     * Versteckt Ads (fuer Pro-User)
     */
    hideAll() {
        this.slots.forEach((id) => {
            const el = document.getElementById(id);
            if (el) el.style.display = 'none';
        });
    }
}

export const adManager = new AdManager();
